import { gql } from 'apollo-angular';

export const AddFunnelToFavouriteDocument = gql`
  mutation addFunnelToFavourites($funnelId: Int!) {
    addFunnelToFavourites(funnelId: $funnelId)
  }
`;
